export default defineAppConfig({
  title: "Агропромшина B2B",
  carousel: {
    autoSlideDelayMs: 12000,
    animationDurationMs: 900,
    fadeEnabled: true,
    leaveOpacity: 0.6,
  },
  theme: {
    dark: true,
    colors: {
      primary: "#e14225",
    },
  },
});
